import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Tabs, ViewController, Events } from 'ionic-angular';
import { FichaPhotoRecettePage } from './ficha-photo-recette/ficha-photo-recette';
import { FichaMedicionPage } from './ficha-medicion/ficha-medicion';
import { HomePage } from '../home/home';
import { FichaPhotoModelPage } from './ficha-photo-model/ficha-photo-model';
import { FichaDataPacientPage } from './ficha-data-pacient/ficha-data-pacient';
import { PatientService } from '../../services/patient.service';

/**
 * Generated class for the FichaTabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ficha-tabs',
  templateUrl: 'ficha-tabs.html',
})
export class FichaTabsPage {

  tabMedidas;
  tabReceta;
  tabModelo;
  tabPaciente;
  pacienteSeleccionado = {};// new Medicion();
  tabOpen = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public viewCtrl: ViewController, private events: Events, private patientApi: PatientService, private patientSdk: PatientService) {

    this.pacienteSeleccionado = navParams.get('result'); //descomentanar para mongo
    console.log(" ****PACIENTE SELECCIONADO ", this.pacienteSeleccionado)
    let datos = navParams.get('result');
    events.subscribe('medicion:save', (user) => {      //this.navCtrl.popToRoot();      
      alert("yes" + user.idmedicion)
      // this.pacienteSeleccionado =  this.patientApi.findById(this.pacienteSeleccionado.id)

    })

   


    //
    this.tabMedidas = FichaMedicionPage;
    this.tabReceta = FichaPhotoRecettePage;
    this.tabModelo = FichaPhotoModelPage;
    this.tabPaciente = FichaDataPacientPage;

    if (this.pacienteSeleccionado) {


      // alert(this.resultPrueba.recipe.framePicture);
      // this.imageModeloLente = this.resultPrueba.recipe.framePicture;
      //  this.imageReceta = this.resultPrueba.recipe.recipePicture;
      //  this.mmMarkers = this.resultPrueba.result.mmMarkersDistance;
      // alert(JSON.stringify(this.resultPrueba.company));
    }
  }
  myMethod() {
    return JSON.stringify(this.pacienteSeleccionado)
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad FichaTabsPage');
  }
  public onClickCancel() {
    //this.viewCtrl.dismiss();
    //  this.navCtrl.push(HomePage);
    this.navCtrl.setRoot(HomePage);
  }
}


/*
export class Medicion {
  idmedicion: number;
  company: string;
  emailcompany: string;
  name: string;
  lastname: string;
  number: string;
  recipeframemodel: string;
  recipeframepicture: string;
  reciperecipepicture: string;
  reciperecipe: string;
  image: string;
  resultmarkersleft1: number;
  resultmarkersleft2: number;
  resultmarkersright1: number;
  resultmarkersright2: number;
  resultpupilsleft1: number;
  resultpupilsleft2: number;
  resultpupilsright1: number;
  resultpupilsright2: number;
  resultframetopleft1: number;
  resultframetopleft2: number;
  resultframetopright1: number;
  resultframetopright2: number;
  resultframebotleft1: number;
  resultframebotleft2: number;
  resultframebotright1: number;
  resultframebotright2: number;
  resultnosebridgetop1: number;
  resultnosebridgetop2: number;
  resultnosebridgebot1: number;
  resultnosebridgebot2: number;
  resultmmcameradistance: number;
  resultpxmarkersdistance: null;
  resultpxpupilsdistance: null;
  resultpxleftpupiltobridge: null;
  resultpxrightpupiltobridge: null;
  resultpxleftpupiltotopframe: null;
  resultpxleftpupiltobotframe: null;
  resultpxrightpupiltotopframe: null;
  resultpxrightpupiltobotframe: null;
  resultmmtotalpupildistance: number;
  resultmmmarkersdistance: number;
  resultmmpupilsdistance: number;
  resultmmleftpupiltobridge: number;
  resultmmrightpupiltobridge: number;
  resultmmleftpupiltotopframe: number;
  resultmmleftpupiltobotframe: number;
  resultmmrightpupiltotopframe: number;
  resultmmrightpupiltobotframe: number;
  created: Date;
  avatar: string;
  empresaid: string;
  state: number;
  empresa: string;
  idMongo: string;
}*/


// WEBPACK FOOTER //
// ./src/pages/ficha-tabs/ficha-tabs.ts